import { render, staticRenderFns } from "./ProcessCreateOrderDocumentationOrderType.vue?vue&type=template&id=8119b6aa&scoped=true"
import script from "./ProcessCreateOrderDocumentationOrderType.vue?vue&type=script&lang=js"
export * from "./ProcessCreateOrderDocumentationOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119b6aa",
  null
  
)

export default component.exports